/*
 * @Author: cn1994
 * @Date: 2023-02-26 15:29:45
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:33:21
 * @Description: file content
 */
const routes = [{
  path: '/taskCenter', // 任务中心页面
  name: 'taskCenter',
  meta: {
    title: '教材分享进度',
    volcengine: true,
  },
  component: () => import('../pages/taskCenter/index.vue'),
}
]

export default routes
